<template>
  <div v-if="ncstraining" class="mx-auto">
    <div class="clearfix">
      <div class="float-left w-50">
        <mdb-tabs default :active="0" @activeTab="onActiveTab" class="mb-3"
          :links="[
            { text: '훈련 개요'},
            { text: '교과 편성'},
            { text: '문제 은행'},
          ]"/>
      </div>
      <div class="float-right text-right">
        <mdb-btn icon="list" class="p-2" @click="onBack">훈련 목록</mdb-btn>
        <mdb-btn icon="save" class="p-2" @click="onSave">저장</mdb-btn>
        <mdb-btn icon="times" color="danger" class="p-2" @click="onDelete">삭제</mdb-btn>
      </div>
    </div>
    <staff-ncs-training-intro :ncstraining="ncstraining" v-if="active ===0"/>
    <staff-ncs-training-lecture :ncstraining="ncstraining" v-if="active ===1"/>
    <staff-ncs-training-question-bank :ncstraining="ncstraining" v-if="active ===2"/>
    <div class="text-center my-5">
    </div>
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import NcsTraining from '@/models/NcsTraining'
import StaffNcsTrainingIntro from './intro/StaffNcsTrainingIntro.vue'
import StaffNcsTrainingLecture from './lecture/StaffNcsTrainingLecture.vue'
import StaffNcsTrainingQuestionBank from './questionbank/StaffNcsTrainingQuestionBank.vue'
export default {
  name: 'StaffNcsTrainingDetailPage',
  components: { mdbTabs, StaffNcsTrainingIntro, StaffNcsTrainingLecture, StaffNcsTrainingQuestionBank },
  props: [],
  data: () => ({
    TAG: 'StaffNcsTrainingDetailPage.vue',
    ncstraining: undefined,
    active: 0
  }),
  computed: {
    ...mapState('auth', ['org'])
  },
  methods: {
    async load () {
      if (this.$route.query.ncstraining) { // 수정
        this.ncstraining = await NcsTraining.get(this.$route.query.ncstraining)
      } else if (this.org._id) { // 추가
        // const org = { _id: this.$route.query.org, name: '테스트 기관' }
        this.ncstraining = NcsTraining.create(this.org)
      }
    },
    onBack () {
      this.$router.back()
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      this.ncstraining = await this.ncstraining.save()
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      if (this.ncstraining._id) {
        await this.ncstraining.delete()
      }
      this.$router.back()
    },
    onActiveTab (index) {
      this.active = index
    }
  },
  watch: { org: 'load' },
  created () { this.load() }
}
</script>
<style scoped>

</style>
